import CheckboxGroupAccordion, {
	CheckboxLists,
} from 'Presentation/Components/KumopackSidebar/CheckboxGroupAccordion'

import { toAbsoluteUrl } from '_metronic/helpers'

import {
	MOCK_PRODUCT_TYPE_1,
	
} from 'Configuration/Presentation/Views/Products/NewProduct/MockProductCheckboxGroup'


const ProductCategorySelect: React.FC = () => {
	return (
		<div className="card border border-kumopack-grey-200">
			{/* begin:: Product Lines */}
			<CheckboxGroupAccordion
				defaultShow
				boxGroupId={MOCK_PRODUCT_TYPE_1.group_id}
				title={
					<>
						<img
							className="me-2"
							src={toAbsoluteUrl('/media/icons/kumopack/folder.png')}
							alt="Product Type Icon"
						/>
						Select Product Category
					</>
				}
				tabNames={MOCK_PRODUCT_TYPE_1.tabs}
				tabContents={[
					<CheckboxLists lists={MOCK_PRODUCT_TYPE_1.list1} />,
					<CheckboxLists lists={MOCK_PRODUCT_TYPE_1.list2} />,
				]}
			/>
			{/* end:: Product Lines */}
		</div>
	)
}

export default ProductCategorySelect
